const moduleNameKey = "editWidgetDrawerModal";

export const editWidgetDrawerModalEn = {
  [moduleNameKey]: {
    title: "Edit Widget",
    noWidgetSelected: "Select a widget to edit",
  },
};

export const editWidgetDrawerModalPtBr = {
  [moduleNameKey]: {
    title: "Editar Widget",
    noWidgetSelected: "Selecione um widget para editar",
  },
};

export const editWidgetDrawerModalDe = {
  [moduleNameKey]: {
    title: "Widget bearbeiten",
    noWidgetSelected: "Wählen Sie ein Widget zum Bearbeiten aus",
  },
};

export const editWidgetDrawerModalZhHans = {
  [moduleNameKey]: {
    title: "编辑部件",
    noWidgetSelected: "选择一个部件进行编辑",
  },
};

export const editWidgetDrawerModalIt = {
  [moduleNameKey]: {
    title: "Modifica Widget",
    noWidgetSelected: "Seleziona un widget da modificare",
  },
};

export const editWidgetDrawerModalEs = {
  [moduleNameKey]: {
    title: "Editar Widget",
    noWidgetSelected: "Seleccione un widget para editar",
  },
};

// Dutch (nl) — added in this branch to close the long-standing
// module-wide gap (the inventory's `nl` column for this file was empty
// for every metric-related key before this branch; the i18n lookup
// would otherwise return "error: missing translation for ..." for any
// Dutch user landing on the widget drawer today). Covers the new
// cycle-time unit feature + the modified remaining_time formula
// text. The pre-existing metric kinds / slot bindings / row keys
// that the inventory always had empty Dutch for stay empty here
// rather than back-fill guessed Dutch — once the next branch wires
// dedicated Dutch copy the same way we just wired nl for the new
// keys, the gap closes.
export const editWidgetDrawerModalNl = {
  [moduleNameKey]: {
    title: "Widget bewerken",
    noWidgetSelected: "Selecteer een widget om te bewerken",
  },
};

export const editWidgetDrawerModalTr = {
  [moduleNameKey]: {
    noWidgetSelected: "Düzenlemek için bir widget seçin",
    title: "Widget'ı Düzenle",
  },
};
